<script lang="ts">
    import { useLocaleContext, useLocaleISOContext, usePropertiesContext } from '$lib/context';
    import { buildFilterURL } from '$lib/util/searchUtil';
    import { getIdByOptionName } from '$lib/util/util';
    import type { ApiSchemas } from '$lib/api/shopwareApi.js';
    import { extractLine } from '$lib/util/productUtil.js';
    import { t } from 'svelte-i18n';

    const lang = useLocaleContext();
    const isoCode = useLocaleISOContext();
    const properties = usePropertiesContext();

    export let product: ApiSchemas['Product'];

    $: vvmLine = product && properties ? extractLine(product, properties.line, isoCode) : undefined;
    $: lineLink = vvmLine ? buildFilterURL({ line: [getIdByOptionName(properties.line, vvmLine)] }) : '';
</script>

<!--
     maybe add mix-blend-mode
-->
{#if vvmLine}
    <div class="flex items-center text-[0.9375rem] w-full gap-2 uppercase tracking-[0.09em] text-accent text-13px">
        <a href="/{lang}/" class="transition-colors translate-y-[-1px]">{$t('shop.product.wine')}</a>
        <svg
            width="6"
            height="9"
            viewBox="0 0 6 9"
            class="stroke-accent/60 translate-y-[-1px]"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M1 1L5 4.50001L1 8" />
        </svg>
        <a href="/{lang}/search{lineLink && '?filter=' + lineLink}" class="translate-y-[-1px] transition-colors"
            >{vvmLine}</a
        >
    </div>
{/if}
